/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useMemo } from "react";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import "../constants/toolbars";

import Dimensions from "./activeObject/DimensionsText";

import ImageButtons from "./activeObject/ImageButtons";
import TextButtons from "./activeObject/TextButtons";
import OrderButtons from "./activeObject/OrderButtons";

import { useStoreon } from "storeon/react";

import { SIZES } from "../constants";

import OptionsButton from "./OptionsButton";
import styled from "@emotion/styled"

const SubtopBar = props => {
  let { activeObject, isMenuOpened, canvas } = useStoreon(
    "activeObject",
    "isMenuOpened",
    "canvas"
  );
  //FIXME: rework active object storing
  if (canvas && activeObject) {
    const activeObjRef = canvas.getActiveObject();
    if (activeObjRef) {
      activeObject = activeObjRef;
    }
  }
  if (activeObject.mask && !activeObject.hasControls) {
    const maskedObj = canvas.getObjects().find(obj => activeObject.id === obj.clipId) ;
    if (maskedObj) {
      activeObject = maskedObj;
    }
  }

  const imgButtons = <ImageButtons activeObject={activeObject} />;

  const textButtons = useMemo(() => {
    return <TextButtons activeObject={activeObject} />;
  }, [activeObject]);

  const orderButtons = useMemo(() => {
    return <OrderButtons activeObject={activeObject} />;
  }, [activeObject]);

  let objDesc = (
    <React.Fragment>
      {activeObject.type === "image" && !activeObject.order && (
        <React.Fragment>
          <Dimensions obj={activeObject} />
          <div
            css={css`
              display: flex;
            `}
          >
            {imgButtons}
          </div>
        </React.Fragment>
      )}
      {activeObject.type === "i-text" && (
        <React.Fragment>{textButtons}</React.Fragment>
      )}

      {activeObject.order && <React.Fragment>{orderButtons}</React.Fragment>}
    </React.Fragment>
  );

  const DefaultBar = styled.div`
      position: fixed;
      right: 20px;
    `;

  if (!activeObject.id && window.innerWidth < 480) {
    return null;
  }

  return (
    <AppBar
      position="fixed"
      color="default"
      css={css`
        height: 50px;
        z-index: 100;
        position: relative;
        border-bottom: 1px solid #ccc;
        box-shadow: none;
        left: ${isMenuOpened ? SIZES.leftBarOpened : SIZES.leftBar}px;
        width: calc(
          100% - ${isMenuOpened ? SIZES.leftBarOpened : SIZES.leftBar}px
        );
        @media screen and (max-width: 480px) {
          left: 0px;
          width: 100%;
        }
      `}
    >
      <Toolbar
        variant="dense"
        css={css`
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: nowrap;
          overflow-y: auto;
          flex-direction: row;
          > div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: nowrap;
            flex-direction: row;
          }
        `}
      >
        {Boolean(activeObject.width) && objDesc}
        <DefaultBar>
          <OptionsButton canvas={canvas} needRender={activeObject.width ? 0 : 1}/>
        </DefaultBar>
      </Toolbar>
    </AppBar>
  );
};

export default SubtopBar;
